import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import DetailGeGu from '../views/DetailGeGu.vue'
import MoreGeGu from '../components/MoreGeGu.vue'
import DetailJiGou from '../views/DetailJiGou.vue'
import MoreJiGou from '../components/MoreJiGou.vue'
import TodayNorthList from '../components/TodayNorthList.vue'
import HistoryNorthList from '../components/HistoryNorthList.vue'
import DetailBanKuai from '../views/DetailBanKuai.vue'
import Search from '../views/Search.vue'
import HmSearch from '../components/HmSearch.vue'
import DetailJiGouChart from '../views/DetailJiGouChart.vue'
import OldHistoryNorthList from '../components/OldHistoryNorthList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/ss/:code/:name',
    name: 'ggDetail',
    component: DetailGeGu
  },
  {
    path: '/jgchartdetail',
    name: 'jgchartdetail',
    component: DetailJiGouChart
  },
  {
    path: '/ggmore',
    name: 'ggMore',
    component: MoreGeGu
  },
  {
    path: '/jgdetail',
    name: 'jgDetail',
    component: DetailJiGou
  },
  {
    path: '/jgmore',
    name: 'jgMore',
    component: MoreJiGou
  },
  {
    path: '/bkdetail',
    name: 'bkDetail',
    component: DetailBanKuai
  },
  {
    path: '/search',
    name: 'search',
    component: Search
  },
  {
    path: '/hms',
    name: 'HmSearch',
    component: HmSearch
  },
  {
    path: '/todaylist',
    name: 'todaylist',
    component: TodayNorthList
  },
  {
    path: '/historylist',
    name: 'historylist',
    component: HistoryNorthList
  },
  {
    path: '/oldhistorylist',
    name: 'oldhistorylist',
    component: OldHistoryNorthList
  },

]

const router = new VueRouter({
//   mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  next()
})
export default router
